import React, { useState } from 'react';
import {
  Grid, List, Icon, Modal, Header,
} from 'semantic-ui-react';
import SearchHighlightSegment from '../../../SearchHighlightSegment';

const Highlight = ({ searchResult }) => {
  const [open, setOpen] = useState(false);
  return (
    <Modal
      closeIcon
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Icon name="angle right" size="large" color="black" link />}
    >
      <Modal.Header>{`${searchResult.item.user.fullName} "${searchResult.query}" matches`}</Modal.Header>
      <Modal.Content className="search-highlights">
        {searchResult.highlights.map((highlight) => (
          <div key={highlight.field}>
            <Header as="h4">{highlight.field}</Header>
            {highlight.segments.map((segment) => (
              <SearchHighlightSegment key={segment} htmlContent={segment} />
            ))}
            <br />
          </div>
        ))}
      </Modal.Content>
    </Modal>
  );
};

const SearchHighlights = ({ searchResult }) => (
  <Grid columns={2}>
    <Grid.Column width={14} className="card-highlight-content">
      <List className="search-highlights">
        {searchResult.highlights.map((highlight) => (
          <List.Item key={highlight.field}>
            <p>
              <strong>{`${highlight.field} (${highlight.segments.length}): `}</strong>
              <SearchHighlightSegment htmlContent={highlight.segments[0]} />
            </p>
          </List.Item>
        ))}
      </List>
    </Grid.Column>
    <Grid.Column
      width={2}
      textAlign="center"
      verticalAlign="middle"
    >
      <Highlight searchResult={searchResult} />
    </Grid.Column>
  </Grid>
);

export default SearchHighlights;
